import { Routes, Route } from "react-router-dom";
import HomeBoard from '../components/boards/HomeBoard';
import ErrorBoard from '../components/boards/ErrorBoard';
import Quejas from '../components/modulos/QuejasHome';
import ExcelReport from '../components/modulos/Excel';
//import SessionTimeout from '../common/SessionTimeout';
import LoginUser from '../components/users/LoginUser';
import AddQuejaComponent from '../components/modulos/Registro';
import SeguimientoQueja from "../components/modulos/seguimiento";
import RegisterUser from "../components/users/RegisterUser";
// import DetailPostQueja from "../components/modulos/DetailPostQueja";
import SessionTimer from "../components/modulos/SessionTimer";
export const PrivateAppRouter = () => {
  return (
    <>
      {/* <SessionTimeout/> */}
      <Routes>
        <Route path="/login" element={<LoginUser />} />
        <Route path="/seguimiento" element={<SeguimientoQueja />} />
        <Route path="/home" element={<HomeBoard />} />
        <Route path="/error" element={<ErrorBoard />} />
        <Route path="/quejashome" element={<Quejas />} />
        <Route path="/reporte" element={<ExcelReport />} />
        <Route path="api/**"/>
        <Route path="/registro" element={<AddQuejaComponent />} />
        <Route path="/usuarios" element={<RegisterUser />} />
{/*     <Route path="/resumen-queja" element={<DetailPostQueja />} /> */} 
        <Route path="*" element={<ErrorBoard/>} />
      </Routes>
      <SessionTimer />
    </>
  );
};